import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TransactionModelInterface } from 'src/app/interface/transaction-model.interface';
import { TransactionRequestModelInterface } from 'src/app/interface/transaction-request-model.interface';
import { OpenIdProfile } from 'src/app/service/open-id.service';
import { RefundComponent as DialogLedgerRefundComponent } from 'src/app/dialog/ledger/refund/refund.component';
import { RefundComponent as DialogLedgerRequestRefundComponent } from 'src/app/dialog/ledger/request/refund/refund.component';

@Component({
    selector: 'app-view-transaction-refund',
    templateUrl: './refund.component.html',
    styleUrls: ['./refund.component.css'],
})
export class RefundComponent implements OnInit {
    @Input() public transactionModel?: TransactionModelInterface;
    @Input() public openIdProfile?: OpenIdProfile;

    public refundTransaction?: TransactionModelInterface;
    public refundRequest?: TransactionRequestModelInterface;

    public ready = false;

    public isVendor = false;

    public isRefundable = false;

    public asVendor = false;

    constructor(private httpClient: HttpClient, private dialog: MatDialog) {}
    ngOnInit(): void {
        if (this.transactionModel!.receiver_open_id == this.openIdProfile!.id) {
            this.isVendor = true;
        }
        this.getRefundTransaction();
        this.isRefundable = this.transactionModel!.result == 'APPROVED';
        this.asVendor =
            this.transactionModel!.receiver_open_id == this.openIdProfile!.id;
    }

    private getRefundTransaction() {
        let options = {
            params: new HttpParams()
                .set('reference_id', this.transactionModel!.id)
                .set('reference_type', 'TRANSACTION')
                .set('transaction_type', 'REFUND')
                .set('result', 'APPROVED'),
        };
        this.httpClient!.get('transactions/', options).subscribe(
            (response: any) => {
                if (response.count) {
                    this.refundTransaction = response.results[0];
                }

                this.ready = true;
            }
        );
    }

    public refund() {
        this.dialog.open(DialogLedgerRefundComponent, {
            data: {
                transactionModel: this.transactionModel,
                dialogContext: true,
            },
        });
    }

    public requestRefund() {
        const dialogRef = this.dialog.open(DialogLedgerRequestRefundComponent, {
            data: {
                transactionModel: this.transactionModel,
                dialogContext: true,
            },
        });
    }
}
